import axios from 'axios'
import { authorizationCheck } from './auth.service'
import {
  ActivityOutcome,
  CareerExplorationType,
  CompletionStatus,
  IncentiveEarned,
  IncentiveType,
  ParticipantOutcome, SupportiveService, WageFrequency
} from './Model/Outcome'

const { NODE_ENV, REACT_APP_EM_API_URL } = process.env

const FAKE_DATA:ParticipantOutcome = {
  "startDate": new Date("2018-09-04"),
  "dropReason": null,
  "trainingHours": 0,
  "placedJob": true,
  "placedTraining": false,
  "placedDirect": false,
  "placedJobDate": new Date("2025-02-13T00:00:00.000Z"),
  "incumbentEmployer": "K&B HVAC/R LLC",
  "jobPlacementEmployer": "K&B HVAC/R LLC",
  "jobPlacementEmployerAddress1": "test",
  "jobPlacementEmployerAddress2": "test",
  "jobPlacementEmployerCity": "Little Compton",
  "jobPlacementEmployerState": "RI",
  "jobPlacementEmployerZipcode": "02801",
  "jobPlacementOccupation": "Architecture and Engineering Occupations",
  "jobPlacementIndustry": "Accomodation and Food Services",
  "jobPlacementWage": 8.9,
  "jobPlacementWageFrequency": "HOUR",
  "jobPlacementWeeklyHours": 9,
  "benefitsProvided": true,
  "perDiem": null,
  "wageIncrease": false,
  "promotion": false,
  "earnedDegreeOrCredit": false,
  "creditsEarned": 0,
  "credential1": "test1",
  "credential2": null,
  "credential3": null,
  "wblType": "Service Learning Project",
  "classroomHours": 0,
  "unpaidHours": 9,
  "paidHours": null,
  "stipendReceived": false,
  "stipendAmount": 8.9,
  "academicCredit": "Unknown",
  "academicAwardDetail": null,
  "internshipOccupation": "Sales and Related Occupations",
  "internshipEmployer": "TEST RITE PRODUCTS CORP",
  "positionBackfilled": false,
  "jobTitle": "test",
  "incentiveEarned": IncentiveEarned.INCENTIVE,
  "incentiveType": null,
  "internshipIndustry": "Finance and Insurance",
  "stipendFrequency": null,
  "wageAmount": null,
  "wageFrequency": null,
  "completionStatus": CompletionStatus.COMPLETED,
  "completionDate":new Date("2025-02-13"),
  "serviceProvided": true,
  "serviceStartDate": new Date("2010-01-01"),
  "serviceEndDate": new Date("2010-01-02"),
  "services": [
  ],
  "participantEnrollmentType": 1,
  "dateCredentialAttained1": new Date("2024-12-16"),
  "dateCredentialAttained2": null,
  "credentialType": "Secondary school diploma or equivalency",
  "credentialType2": "No recognized credential",
  "credentialDoc1Uploaded": null,
  "credentialDoc2Uploaded": null,
  "external_id": "441585",
}
const FAKE_NULL_DATA = {
  "academicAwardDetail": null,
  "academicCredit": null,
  "benefitsProvided": null,
  "classroomHours": null,
  "completionDate": null,
  "completionStatus": null,
  "credential1": null,
  "credential2": null,
  "credential3": null,
  "creditsEarned": null,
  "dropReason": null,
  "earnedDegreeOrCredit": null,
  "incumbentEmployer": null,
  "internshipEmployer": null,
  "internshipOccupation": null,
  "jobPlacementEmployer": null,
  "jobPlacementEmployerCity": null,
  "jobPlacementEmployerState": null,
  "jobPlacementIndustry": null,
  "jobPlacementOccupation": null,
  "jobPlacementWage": null,
  "jobPlacementWageFrequency": null,
  "jobPlacementWeeklyHours": null,
  "paidHours": null,
  "placedDirect": null,
  "placedJob": null,
  "placedJobDate": null,
  "placedTraining": null,
  "positionBackfilled": null,
  "promotion": null,
  "startDate": null,
  "stipendAmount": null,
  "stipendReceived": null,
  "trainingHours": null,
  "unpaidHours": null,
  "wageIncrease": null,
  "wblType": null,
  "serviceProvided": null,
  "serviceStartDate": null,
  "serviceEndDate": null,
  "services": [],
  dateCredentialAttained1: null,
  dateCredentialAttained2: null,
  credentialType: null,
  credentialType2: null,
  credentialDoc1Uploaded: null,
  credentialDoc2Uploaded: null,
}

const FAKE_NULL_ACTIVITY_DATA: ActivityOutcome = {
	currentGrade: null,
	careerExplorationType: null,
	creditsEarned: null,
	endDate: null,
	incentiveEarned: null,
	incentiveType: null,
	schoolNames: null,
	stipendAmount: null,
	stipendFrequency: null,
	startDate: null,
	totalHours: null,
	totalParticipantsCompleted: null, // TODO - Change initial value
	totalParticipantsEnrolled: null,
	wageAmount: null,
	wageFrequency: null,
}

const FAKE_ACTIVITY_DATA: ActivityOutcome = {
  careerExplorationType: CareerExplorationType.JOB_SHADOW,
  credential1: "Cred1",
  credential2: "Cred3",
  credential3: "Cred4",
  credentialType: "Industry",
  creditsEarned: 3,
  currentGrade: 11,
  endDate: new Date("2020-06-10"),
  incentiveEarned: IncentiveEarned.INCENTIVE,
  incentiveType: IncentiveType.FOOD,
  schoolNames: "Test School 1, Test School 3, Test School 3, Bryant University, Brown University, Test School 1",
  startDate: new Date("2020-06-04"),
  stipendAmount: null,
  stipendFrequency: null,
  stipendReceived: null,
  totalHours: 1,
  totalParticipantsCompleted: 1,
  totalParticipantsEnrolled: 1,
  wageAmount: null,
  wageFrequency: null
}

const sendNulls = false

export const getParticipantOutcomes = async (activityID: string, participantID: string):Promise<ParticipantOutcome> => {
  if(NODE_ENV !== 'production') {
    return await sendNulls ? FAKE_NULL_DATA : FAKE_DATA
  }

 const { data, status } = await axios
   .get(`${REACT_APP_EM_API_URL}/activities/${activityID}/participants/${participantID}/outcomes`)


  authorizationCheck(status)
  return data
} 

export const updateParticipantOutcomes = async (
  activityID: string,
  participantID: string,
  outcomesData: ParticipantOutcome
) => {
  if(NODE_ENV !== 'production') {
    return await {errors:["Error in uploading credential 1 to EmployRI."]}
  }

  try {
    const { data, status } = await axios
      .put(`${REACT_APP_EM_API_URL}/activities/${activityID}/participants/${participantID}/outcomes`, {...outcomesData,credentialDoc1:null,credentialDoc2:null})

    authorizationCheck(status)
    return data
  }catch (e) {
    throw e
  }
}

export const uploadDocument = async (
  activityID: string,
  participantID: string,
  outcomesData: any
) => {
  try {
    const { data, status } = await axios
      .put(`${REACT_APP_EM_API_URL}/activities/${activityID}/participants/${participantID}/outcomes/uploadDocument`, outcomesData)

    authorizationCheck(status)
    return data
  }catch (e) {
    throw e
  }
}

async function stall(stallTime = 300) {
  await new Promise(resolve => setTimeout(resolve, stallTime));
}

export const getActivityOutcomes = async (activityID: string): Promise<ActivityOutcome> => {
  if (NODE_ENV !== 'production') {
    await stall(300)
    return await (sendNulls) ? FAKE_NULL_ACTIVITY_DATA : FAKE_ACTIVITY_DATA
  }
  try {
    const { data, status } = await axios.get(
      `${REACT_APP_EM_API_URL}/activities/${activityID}/outcome`
    )

    authorizationCheck(status)
    return data
  } catch (e) {
    throw e
  }
}

export const updateActivityOutcomes = async (activityID: string, outcomesData: ActivityOutcome) => {
  if (NODE_ENV !== 'production') {
    return await { ...FAKE_DATA, ...outcomesData }
  }

  try {
    const { data, status } = await axios.put(
      `${REACT_APP_EM_API_URL}/activities/${activityID}/outcome`,
      outcomesData,
    )

    authorizationCheck(status)
    return data
  } catch (e) {
    throw e
  }
}

export const getEmployers = async ():Promise<any> => {
  if(NODE_ENV !== 'production') {
    return [{
      "employer_name": "HV COLLINS COMPANY123",
      "street": "123 Main St",
      "city": "Providence",
      "state": "RI",
      "zip_code": "02903",
      "id":1
  },{
    "employer_name": "test1",
    "street": "test1",
      "city": "Providence",
      "state": "AK",
      "zip_code": "02903",
      "id":2
  },{
    "employer_name": "xyz",
    "street": "xyz",
      "city": "Providence",
      "state": "RI",
      "zip_code": "02903",
      "id":3
  },{
    "employer_name": "test2",
    "street": "test2",
      "city": "Providence",
      "state": "RI",
      "zip_code": "02903",
      "id":4
  },{
    "employer_name": "test456",
    "street": "test456",
      "city": "Providence",
      "state": "RI",
      "zip_code": "02903",
      "id":5

  }]
  }

  try {
      const { data, status } = await axios.post(`${REACT_APP_EM_API_URL}/employers`)
      authorizationCheck(status)
      return data
  } catch (error) {
    if (axios.isCancel(error)) {
      console.log('Request canceled', error);
    } else {
      console.error('Error fetching data', error);
    }
  }
 
}

